import React, { useState, useEffect } from 'react';

const LogoPreview = ({ logoData, alt }) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);

  useEffect(() => {
    if (logoData && logoData.startsWith('http')) {
      setImageLoading(true);
      setImageError(false);
    }
  }, [logoData]);

  const handleImageLoad = () => {
    setImageLoading(false);
  };

  const handleImageError = () => {
    setImageError(true);
    setImageLoading(false);
  };

  if (!logoData) return null;

  if (imageError) {
    return (
      <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gray-200 rounded flex items-center justify-center text-xs text-gray-500">
        Failed to load
      </div>
    );
  }

  return (
    <div className="relative">
      {imageLoading && (
        <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gray-200 rounded flex items-center justify-center">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
        </div>
      )}
      <img
        src={logoData}
        alt={alt}
        className="w-10 h-10 sm:w-12 sm:h-12 object-cover rounded"
        onLoad={handleImageLoad}
        onError={handleImageError}
        style={{ display: imageLoading ? 'none' : 'block' }}
      />
    </div>
  );
};

export default LogoPreview;
